module.exports = __webpack_public_path__ + "img/1F1F9-1F1EC.a16b7d5c.svg";